export const NW_DASHBOARD_IS_MODAL = "NW_DASHBOARD_IS_MODAL"
export const NW_DASHBOARD_IS_CONFIRMATION_MODAL = "NW_DASHBOARD_IS_CONFIRMATION_MODAL"
export const NW_DASHBOARD_SET_TEAM_PAGE = "NW_DASHBOARD_SET_TEAM_PAGE"
export const NW_DASHBOARD_SET_PROJECT_PAGE = "NW_DASHBOARD_SET_PROJECT_PAGE"